/*
	Author: xowei <wei@xowei.tw>
	Website: https://xowei.tw/
*/

$(function () {
	var $hud = $('.hud')
	var $preload = $('.preload')
	var $nav = $('nav')
	var $window = $(window)

	$hud.hide()
	$window.on({
		'scroll': function () {
			windowScroll = $(window).scrollTop()
	
			if (windowScroll < window.visualViewport.height) {
				if ($hud.length) $hud.hide()
			} else {
				if ($hud.length) $hud.show()
			}
	
			if ($nav.length) {
				windowScroll > 0 ? $nav.addClass('bg') : $nav.removeClass('bg')
			}
		},
		'load': function () {
			$preload.fadeOut('slow')
			initAnimation()
		}
	})

	navLinkClick('#navContent a')
	smoothScroll('#navContent a')
	smoothScroll('#gototop')
})

function navLinkClick(target) {
	$(target).on('click', function () {
		if ($(this).attr('role') == 'dropdown') {
			$(this).toggleClass('list-open')
			$(this).siblings('ul').toggleClass('is-hidden')
		} else {
			$('.nav-icon').click()
		}
	})
}

function smoothScroll(target) {
	var $body = $('body, html')
	var $linkPosition
	var $nav = $('nav')

	$(target).each(function () {
		var $link = $(this)
		$linkPosition

		$link.on('click', function (e) {
			e.preventDefault()
			var tab = $link.attr('role')

			if (!tab) {
				var $target = $($(this).attr('href'))
				$iconHeight = $('.product-title .icon').height()
				$linkPosition = ($target.length ? $target.offset().top : 0) - $nav.height()

				if ($target.is(':not(":first-child")')) {
					$linkPosition -= $iconHeight / 2
				}

				$body.animate({
					scrollTop: $linkPosition,
				})
			}
			$(this).blur()
			$(this).focusout()
		})
	})
}

function initAnimation () {
	$('.embed').each(function () {
		$(this).attr({
			'data-aos': 'fade-in',
		})
	})

	$('.block-mainTitle').each(function () {
		if ($(this).hasClass('block-mainTitle--line')) {

			$(this).attr({
				'data-aos': 'fade-in',
				'data-aos-delay': 100,
			})
			
			$(this).find('~ p').each(function () {
				$(this).attr({
					'data-aos': 'fade-up',
					'data-aos-delay': 100,
				})
			})

		} else {

			$(this).find('p').each(function (index) {
				let delay = 200 * index
	
				$(this).attr({
					'data-aos': 'fade-up',
					'data-aos-delay': delay,
				})
			})

		}
	})

	$('.block-method').each(function () {
		$(this).find('.block-method-title').attr({
			'data-aos': 'fade-in',
		})
		
		$(this).find('.block-method-content').attr({
			'data-aos': 'fade-in',
		})

		$(this).find('.block-method-subTitle').attr({
			'data-aos': 'fade-in',
			'data-aos-delay': '300'
		})

		$(this).find('.row').each(function (rowIndex) {
			$(this).find('[class^="col"]').each(function (colIndex) {
				$(this).attr({
					'data-aos': 'fade-left',
					'data-aos-delay': 200 * colIndex
				})
			})
		})
	})

	$('.series').each(function () {
		let delay = 200 * $(this).index()
		let reverse = $(this).hasClass('flex-md-row-reverse')

		$(this).find('.series-title').each(function () {
			$(this).attr({
				'data-aos': 'fade-up',
			})
		})

		$(this).find('.series-demo').each(function () {
			$(this).attr({
				'data-aos': 'fade-up',
			})
		})

		$(this).find('.series-demo img').each(function () {
			$(this).attr({
				'data-aos': 'fade-up',
				'data-aos-delay': delay + 400,
			})
		})

		$(this).find('.series-text').each(function () {
			$(this).attr({
				'data-aos': reverse ? 'fade-right' : 'fade-left',
				'data-aos-delay': delay,
			})
		})

		$(this).find('.series-image').each(function () {
			$(this).attr({
				'data-aos': reverse ? 'fade-right' : 'fade-left',
				'data-aos-delay': delay + 200,
			})
		})
	})

	$('.block').each(function() {
		$(this).find('.block-debut').attr({
			'data-aos': 'fade-up',
			'data-aos-delay': '1000'
		})
		
		$(this).find('.block-title').each(function () {
			let delay = 200 * $(this).index()
			
			$(this).attr({
				'data-aos': 'fade-left',
				'data-aos-delay': delay,
			})
		})

		$(this).find('.block-subTitle').attr({
			'data-aos': 'fade-left',
			'data-aos-delay': '400'
		})

		$(this).find('.block-image').attr({
			'data-aos': 'fade-right',
			'data-aos-delay': '600'
		})

		$(this).find('.block-name').attr({
			'data-aos': 'fade-left',
		})

		$(this).find('.block-cta').attr({
			'data-aos': 'fade-left',
			'data-aos-delay': '600'
		})

		$(this).find('.block-feature').each(function (index) {
			let delay = 200 * index

			$(this).attr({
				'data-aos': 'fade-left',
				'data-aos-delay': delay,
			})
		})

		$(this).find('.block-info').each(function () {
			$(this).find('.block-info-title').attr({
				'data-aos': 'fade-up',
			})

			$(this).find('.block-info-image').attr({
				'data-aos': 'fade-left',
				'data-aos-delay': 200 * $(this).find('.block-info-list li').length,
			})

			$(this).find('.block-info-list li').each(function (index) {
				let delay = 200 * index

				$(this).attr({
					'data-aos': 'fade-up',
					'data-aos-delay': delay,
				})
			})
		})
	})

	$('.step').each(function() {
		let delay = 400 * $(this).index()

		$(this).attr({
			'data-aos': 'fade-up',
			'data-aos-delay': delay,
		})
	})

	$('.customer').each(function(index) {
		let isOdd = Boolean(index%2)
		console.log(index, isOdd)
		$(this).find('.image').attr({
			'data-aos': 'fade-up',
			'data-aos-delay': 400
		})
		$(this).find('.text').attr({
			'data-aos': isOdd ? 'fade-right' : 'fade-left',
		})
		$(this).find('.customer-cta').attr({
			'data-aos': 'fade-up',
			'data-aos-delay': 200
		})
	})

	AOS.init({
		duration: 1000,
		once: true,
	})
}
